/**
 * @generated SignedSource<<bdb40943032ead4b11265172a55c9949>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbId",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Action__CancelReservationPayload",
    "kind": "LinkedField",
    "name": "actionCancelReservation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Entity",
        "kind": "LinkedField",
        "name": "entity",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availability",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EntityState",
            "kind": "LinkedField",
            "name": "entityStates",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dueDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionCancelReservationMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActionCancelReservationMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "64ff72e8a9c2c0017d8a8830fd637020",
    "id": null,
    "metadata": {},
    "name": "ActionCancelReservationMutation",
    "operationKind": "mutation",
    "text": "mutation ActionCancelReservationMutation(\n  $input: Action__CancelReservationInput!\n) {\n  actionCancelReservation(input: $input) {\n    entity {\n      id\n      dbId\n      availability\n      entityStates {\n        id\n        dbId\n        state\n        dueDate\n        userId\n      }\n    }\n    error\n  }\n}\n"
  }
};
})();

node.hash = "3a205143c8cd2a7fe79303385a1695bf";

module.exports = node;
